export default __webpack_public_path__ + "static/media/authCoverImg.89e11563.png";